import React from "react";
import Proyecciones from "../../partials/proyecciones";
import * as Funciones from "../../../../utils/funciones";
import styles from './graficos.module.css';

const Graficos = ({ productos, textosLegales }) => {
    return (
        <React.Fragment>
            <div className={styles.wrapFirstcols}>
                <Proyecciones
                    productos={Funciones.ordenarListaXCampo(false, productos, 'codigoTipoProducto')}
                    textosLegales={textosLegales}
                />
            </div>
        </React.Fragment>
    )
}

export default Graficos;